import { types, actions } from './requests'
export const GETPAGEDCOSTLIST_TYPES = {
    ...types('GETPAGEDCOSTLIST'),
}
export const GETPAGEDCOSTLIST_ACTIONS = {
    ...actions('GETPAGEDCOSTLIST'),
}
